import * as ROUNDS_API from '@/constants/roundsApiEndpoints'
import router from '@/router'

// Report Service Plugin
class ReportService {
  constructor (Vue) {
    this.Vue = Vue;
    this.watch = new Vue({
      data () {
        return {
          reports: [],
          loading: true
        };
      }
    });

    // Fetch data on instantiation
    // this.refreshData();
  }

  get reports () {
    return this.watch.reports
  }

  set reports (reports) {
    this.watch.reports = reports;
  }

  get loading () {
    return this.watch.loading
  }

  set loading (loading) {
    this.watch.loading = loading;
  }

  refreshData(teamId) {
    if (!!teamId) {
      teamId = this.Vue.$teamService.currentTeamId
    }
    if (this.Vue.$auth.watch.authenticated && teamId) {
      this.loading = true;
      var options = {
        credentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        params: {
          teamId: teamId
        }
      }
      this.Vue.http.get(ROUNDS_API['API_ENDPOINT_STATUS_REPORTS'], options).then(res => res.json()).then(
        // Success Calback
        response => {
          if (!response || response.errorMessage) {
            // Error Callback
            this.refreshDataFailureCallback(response);
          } else {
            this.reports = response;
            this.loading = false;
          }
        },

        // Error Callback
        response => {
          this.refreshDataFailureCallback(response);
        }
      );
    }
  }

  refreshDataFailureCallback (response) {
    this.loading = false;

    // Log exception in Google Analytics
    if (response && (response.length || Object.keys(response).length)) {
      const exception = response.errorMessage || response;
      this.Vue.$ga.exception(exception);
    }

    // Log user out if request authorization fails
    if (response.errorMessage && response.errorMessage.match(/^E_AUTH_.+/)) {
      this.Vue.$auth.logout().then(router.accessDenied);
    }
  }
}

const reportService = {
  install: function (Vue, options) {
    const instance = new ReportService(Vue);
    Vue.prototype.$reportService = instance
    Vue.$reportService = instance;
  }
};

export default reportService;



// WEBPACK FOOTER //
// ./src/services/ReportService.js